
<div (keydown)="testEnter($event)">
<ng-select #ngSelect [items]="filteredOptions" bindLabel="text" bindValue="value" [(ngModel)]="currentValueValue" 
  (keypress)="onKeyPress($event)"  [searchable]="searchable"   (search)="onSearch($event)"
  (change)="select($event )" [disabled]="disabled" [id]="index">
</ng-select>
</div>